import boxShadows from './boxShadows'
import { Amaranth, LakeBlue, Midnight } from './colours'

/**
 * - Style override to MUIInputBase to match figma
 * - https://www.figma.com/file/kfXA1bse9Xd24MjmTDOjJo/B2B?node-id=1168%3A1461
 */
const inputBase = {
  styleOverrides: {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    root: ({ ownerState }: any) => ({
      '&.MuiOutlinedInput-root': {
        '&:hover': {
          fieldset: {
            '&.MuiOutlinedInput-notchedOutline': {
              border: `1px solid ${Midnight[40]}`,
            },
          },
        },
        '&.Mui-focused': {
          fieldset: {
            '&.MuiOutlinedInput-notchedOutline': {
              border: `1px solid ${LakeBlue[40]}`,
              boxShadow: boxShadows.textFieldFocused,
            },
          },
        },
        '&.Mui-error': {
          fieldset: {
            '&.MuiOutlinedInput-notchedOutline': {
              border: `1px solid ${Amaranth[100]}`,
            },
          },
        },
      },
      fieldset: {
        borderRadius: '8px',
        '&.MuiOutlinedInput-notchedOutline': {
          border: `1px solid ${Midnight[10]}`,
        },
      },
      ...(!ownerState.multiline && {
        height: '48px', // height for text field only. textarea will use MUI calculation for height
      }),
    }),
  },
}

export default inputBase
